import Link from 'next/link'
import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
`
export const Product = styled(Link)`
  display: block;
  width: 100%;
  color: var(--brand-secondary);
  text-decoration: none;

  &:hover > div:first-child {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.12);
  }
`
export const Image = styled.div`
  width: 100%;
  height: 240px;
  background-size: cover;
  background-position: center center;
  border-radius: 20px;
  transition: 0.1s ease-in-out;

  @media (max-width: 1200px) {
    height: 180px;
  }
`
export const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;

  & > svg {
    margin-right: 6px;
  }
`
export const Name = styled.h3`
  margin-top: 8px;
  line-height: 18px;
`
export const Tour = styled.span`
  margin-top: 4px;
  color: grey;
  display: block;
  font-weight: var(--font-light);
`
export const FromPrice = styled.span`
  margin-top: 12px;
  display: block;
`

export const PointsBadgeContainer = styled.div`
  margin-top: 8px;
`
